import React from "react";

const HelpContact = () => (
  <section className="w-full bg-light-6 py-12 px-6 text-center">
    <h3 className="text-title font-bold text-dark-1 mb-4">Toujours besoin d’aide ?</h3>
    <p className="text-normal text-dark-3 mb-6">
      Si tu ne trouves pas ta réponse ici, notre équipe est dispo pour t’aider directement.
    </p>
    <div className="space-y-3 text-light-1">
      <p>📧 Email support : <span className="text-blue-1 font-semibold">support@gonextmaker.com</span></p>
      <p>💬 Chat en direct (si activé)</p>
      <p>📞 Hotline / WhatsApp (optionnel)</p>
    </div>
  </section>
);

export default HelpContact;
